<template>
   <div>

   <!--  <div class="row mrgn-box">
        <div class="col-md-12">
            <div class="box">
                <div class="box-header with-border">
                    <h3 class="box-title">Insight </h3>
                    <select v-model="dateinput"  @change="onChangeDate">
                        <option value="today">Top Pages</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="lastweek">Last 7 Day</option>
                        <option value="lastmounth">Last Mounth</option>
                    </select>
                </div>
                <div class="box-body">
                    <table class="table table-bordered" v-if="!isLoading"> 
                        <thead>
                            <tr>
                                <th>Photo</th>
                                <th>Title</th>
                                <th v-if="dateinput =='today'">User Aktif</th>
                                <th v-else>Total Page Views</th>
                            </tr>

                        </thead>
                         
                        <tbody  v-for="(item,index) in results" v-if="item.author !=''">    
                          
                            <tr v-if="item.type == 'today'">
                              <td rowspan="2" ><img :src="item.thumbnail" width="50" height="50"></td>
                              <td ><a :href="item.url">{{ item.title }}</a></td>
                              <td rowspan="2">{{ item.active_user }}</td>
                            </tr> 
                            <tr v-if="item.type == 'today'">
                                <td>{{ item.pageviews }} views perhari | Author : {{ item.author }}</td>
                            </tr> 

                            <tr v-if="item.type != 'today'">
                              <td rowspan="2" ><img :src="item.thumbnail" width="50" height="50"></td>
                              <td ><a :href="item.url">{{ item.title }}</a></td>
                             <td rowspan="2">{{ item.pageviews }}</td>
                            </tr> 
                           

                        </tbody>
                       
                       
                    </table>
                     <loading-block v-else />
                </div>

            </div>
        </div>        

    </div>   -->  
  

    </div>    
</template>

<script>
import axios from "axios";
import PolarChart from "../../mobile/PolarChart"
import moment from "moment";

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
   // name: "Analytic",
    components: {
        PolarChart,
        DateRangePicker
    },
    data() {
        return {
            datacollection: {},
            isLoading: true,
            dateinput:'today',
          
            dateRange: {},
            startDate: '',
            endDate: '',
            minDate: '',
            maxDate: '',
           
            articles: [],
            results:[],
            loadingArticle: true
        };
    },
    async created() {
      
        await this.getAnalytics()
    
    },
    methods: {
       
        getAnalytics() {
            this.isLoading = true;
            const token = this.$cookies.get('token');
            axios.get(`/api/insight?date=`+ this.dateinput, { headers: {"Authorization" : `Bearer ${token}`} })
            
                .then((response) => {
                    this.isLoading = false;
                    this.results = response.data;
                    
                })
                .catch((error) => {

                });
        },
        onChangeDate(){
           this.isLoading = true;
           const token = this.$cookies.get('token');
            axios.get(`/api/insight?date=`+ this.dateinput, { headers: {"Authorization" : `Bearer ${token}`} })
            
                .then((response) => {
                    this.isLoading = false;
                    this.results = response.data;
                    
                })
                .catch((error) => {

                });

        },

        async getArticle(start_date, end_date) {
            const token = this.$cookies.get('token');
            await axios.get(`/api/analytic/list?start_date=${start_date}&end_date=${end_date}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.articles = this.topArticle(response.data, 10);
                    this.loadingArticle = false
                })
                .catch((error) => {

                });
        },

        topArticle(arr, total) {
            // filter top 5 popular articles
            if (total)
                return arr.sort((a, b) => b.view_count - a.view_count).slice(0, total);

            return arr.sort((a, b) => b.view_count - a.view_count);
        },

        setMaxDate(value) {
            var start_date = moment(value).format("YYYY-MM-DD")
            this.maxDate = moment(start_date, "YYYY-MM-DD").add(89, 'days').format("YYYY-MM-DD");
        },

        async changeDateRange(value) {
            var start_date = moment(value.startDate).format("YYYY-MM-DD")
            var end_date = moment(value.endDate).format("YYYY-MM-DD")
            const diff = this.getDaysDiff(start_date, end_date);

            this.addParamsToLocation({start_date: start_date, end_date: end_date})

            if(diff > 31) {
                this.$set(this.chartOptions.scales, 'xAxes', [{
                    display: false
                }]);
            } else {
                this.$set(this.chartOptions.scales, 'xAxes', [{
                    display: true
                }]);
            }
            if(diff > 90) {
                this.dateRange = {}
            }
            if(diff <= 90) {
                await this.getAnalytics(start_date, end_date)
                await this.getArticle(start_date, end_date)
                this.minDate = '';
                this.maxDate = '';
            }
        },

        addParamsToLocation(params) {
            history.pushState(
                {},
                null,
                this.$route.path +
                '?' +
                Object.keys(params)
                    .map(key => {
                        return (
                            encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                        )
                    })
                    .join('&')
            )
        },

        dateFormat (classes, date) {
            var d = new Date();
            var month3 = d.setMonth(d.getMonth() - 3);
            var dd = new Date();
            var dateNew = dd.setDate(dd.getDate() + 1);
            if (!classes.disabled) {
                classes.disabled = date.getTime() > dateNew || date.getTime() < month3
            }
            return classes
        },

        getDaysDiff (start_date, end_date, date_format = 'YYYY-MM-DD') {
            const getDateAsArray = (date) => {
                return moment(date.split(/\D+/), date_format);
            }
            return getDateAsArray(end_date).diff(getDateAsArray(start_date), 'days') + 1;
        },

        openSelection() {
            this.minDate = '';
            this.maxDate = '';
        },

        startSelection(value) {
            this.minDate = moment(value, "YYYY-MM-DD");
            this.maxDate = moment(value, "YYYY-MM-DD").add(7, 'days').format("YYYY-MM-DD");
        },

        intToString(num) {
            // source: https://www.html-code-generator.com/javascript/shorten-long-numbers
            if (num < 1000) return num;

            const si = [
                { v: 1e3, s: "K" },
                { v: 1e6, s: "M" },
                { v: 1e9, s: "B" },
                { v: 1e12, s: "T" },
                { v: 1e15, s: "P" },
                { v: 1e18, s: "E" }
            ];

            let i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].v) {
                    break;
                }
            }
            return (
                (num / si[i].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") +
                si[i].s
            );
        }
    }
}
</script>

<style scoped>
/*.analytic {
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 10px;
    background-color: #fff;
}
a:hover {
    text-decoration: none;
}
table {
    width: 100%;
}*/

.mrgn-box{
    margin: 30px -15px!important;
}

.box {
    position: relative;
    border-radius:19px;
    background: #ffffff;
   
    margin-bottom: 20px;
    width: 100%;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
}
.box-header.with-border {
    border-bottom: 1px solid #f4f4f4;
}

.box-header {
    color: #444;
    display: block;
    padding: 14px 13px;
    position: relative;
}

.table-bordered th, .table-bordered td,.table-bordered  {
    border: none!important;
}

.box-header .box-title {
    display: inline-block;
    font-size: 18px;
    margin: 0;
    line-height: 1;
}
</style>
